module.exports = __webpack_public_path__ + "static/teamwork-brandname-ee8b365d267390bab80317f105f50682.png";